// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-scope-nzwye footer{margin-top:0}`, "",{"version":3,"sources":["webpack://./src/page/home/home.less"],"names":[],"mappings":"AAEA,yBAEQ,YAFR","sourcesContent":["@import (reference) '~module/styles/variables.less';\n\n:local(.scope) {\n    footer {\n        margin-top: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"scope": `home-scope-nzwye`
};
module.exports = ___CSS_LOADER_EXPORT___;
